import { useLocation } from "react-router-dom";

type UseUrlQuerysReturn = {
  get: (name: string) => string | null,
  set: (name: string, value: string) => string,
  remove: (name: string) => string,
};

const useUrlQuerys = (): UseUrlQuerysReturn => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  return {
    get: (name) => params.get(name),
    set: (name, value) => {
      params.set(name, value);
      return params.toString();
    },
    remove: (name) => {
      params.delete(name);
      return params.toString();
    },
  };
};

export default useUrlQuerys;
